// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  chatId: __t.u64().primaryKey().name("chat_id"),
  worldId: __t.u64().name("world_id"),
  versonaId: __t.u64().name("versona_id"),
  speaker: __t.string(),
  speakerName: __t.string().name("speaker_name"),
  text: __t.string(),
  answered: __t.bool(),
  at: __t.timestamp(),
});
